import { IDataTypeSerializer, ISerializeContext, IDataType } from '@ecp-caf/common-structure';
import { StructureReferTypeConvertor } from '../../../convertor/data-type/structure-refer-type-convertor';
import { DtoStructureReferType } from '../../../define/data-type/structure-refer-type';

export class GspDtoDataTypeSerializer implements IDataTypeSerializer {
    
    serialize(type: IDataType, ctxt: ISerializeContext): Object {
        let result = new Object();
        let baseConvertor = new StructureReferTypeConvertor();
        baseConvertor.convertToObject(result, type, ctxt);
        return result;
    }

    deserialize(obj: Object, ctxt: ISerializeContext): IDataType {
        let result = new DtoStructureReferType();
        let baseConvertor = new StructureReferTypeConvertor();
        baseConvertor.initFromObject(result, obj, ctxt);
        return result;
    }


}